import { Shape, ShapeOptions } from "../Shape";
import { SVGParsedPathData } from "../../../svg/";
import { YZCanvasContext } from "../canvas";

export type CurveShapeOptions = {
  cx?: number; // 相对于自身（0,0）的坐标
  cy?: number; // 相对于自身（0,0）的坐标
  toX?: number; // 相对于自身（0,0）的坐标
  toY?: number; // 相对于自身（0,0）的坐标
  isLineThrough?: boolean;
} & ShapeOptions;

// 曲线
export class CurveShape extends Shape {
  public cx: number;
  public cy: number;
  public toX: number;
  public toY: number;
  public isLineThrough: boolean;

  constructor(options?: CurveShapeOptions) {
    super(options);
    this.cx = options?.cx || 0;
    this.cy = options?.cy || 0;
    this.toX = options?.toX || 0;
    this.toY = options?.toY || 0;
    this.isLineThrough =
      typeof options?.isLineThrough == "boolean"
        ? options.isLineThrough
        : false;
    this.setAttr({
      strokeWidth: this.getAttr("strokeWidth") || "1",
      stroke: this.getAttr("stroke") || "#000000"
    });
  }

  protected cloneShape(): CurveShape {
    const shape = new CurveShape({
      ...super.getBaseOptions(),
      cx: this.cx,
      cy: this.cy,
      toX: this.toX,
      toY: this.toY,
      isLineThrough: this.isLineThrough
    });
    return shape;
  }

  // 供外部变更
  public update(options: Partial<CurveShapeOptions>) {
    if (typeof options.cx == "number") {
      this.cx = options.cx;
      this.shouldUpdatePathD = true;
    }
    if (typeof options.cy == "number") {
      this.cy = options.cy;
      this.shouldUpdatePathD = true;
    }
    if (typeof options.toX == "number") {
      this.toX = options.toX;
      this.shouldUpdatePathD = true;
    }
    if (typeof options.toY == "number") {
      this.toY = options.toY;
      this.shouldUpdatePathD = true;
    }
    if (typeof options.isLineThrough == "boolean") {
      this.isLineThrough = options.isLineThrough;
      this.shouldUpdatePathD = true;
    }
  }

  public toSVGPathData(): SVGParsedPathData[] {
    if (this.isLineThrough) {
      const c1x = this.cx * 2 - (0 + this.toX) / 2;
      const c1y = this.cy * 2 - (0 + this.toY) / 2;
      return [
        ["m", 0, 0],
        ["q", c1x, c1y, this.toX, this.toY]
      ];
    } else {
      return [
        ["m", 0, 0],
        ["q", this.cx, this.cy, this.toX, this.toY]
      ];
    }
  }

  public toCanvasContext(ctx: YZCanvasContext): void {
    ctx.beginPath();
    ctx.moveTo(0, 0);
    if (this.isLineThrough) {
      const c1x = this.cx * 2 - (0 + this.toX) / 2;
      const c1y = this.cy * 2 - (0 + this.toY) / 2;
      ctx.quadraticCurveTo(c1x, c1y, this.toX, this.toY);
    } else {
      ctx.quadraticCurveTo(this.cx, this.cy, this.toX, this.toY);
    }
  }
}

export default CurveShape;
